import React, { useRef, useState } from "react"
import Button from "@mui/material/Button"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import Switch from "@mui/material/Switch"
import TextField from "@mui/material/TextField"
import { useForm } from "react-hook-form"

import { StyledProductGateDialog } from "./ProductGates.style"

const normalizeCode = (code) => String(code || "").trim()

const ProductGateDlg = (props) => {
  const { onSubmit } = props

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm()

  const [open, setOpen] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const originalCodeRef = useRef("")
  const originalIdRef = useRef(null)

  const openDlg = (existing) => {
    reset()
    setOpen(true)
    if (existing) {
      setIsEditMode(true)
      originalCodeRef.current = normalizeCode(existing.code)
      originalIdRef.current = existing.id
      setValue("name", existing.name || "")
      setValue("code", existing.code || "")
      setValue("id", existing.id ?? "")
      setValue("hubspotContentAccessId", existing.hubspotContentAccessId ?? "")
      setValue("checkoutUrl", existing.checkoutUrl || "")
      setValue("active", typeof existing.active === "boolean" ? existing.active : true)
    } else {
      setIsEditMode(false)
      originalCodeRef.current = ""
      originalIdRef.current = null
      setValue("active", true)
    }
  }

  const handleClose = () => setOpen(false)

  const handleAction = async (data) => {
    const item = {
      id: data?.id ? Number(data.id) : undefined,
      name: String(data?.name || "").trim(),
      code: normalizeCode(data?.code),
      hubspotContentAccessId: data?.hubspotContentAccessId ? Number(data?.hubspotContentAccessId) : null,
      checkoutUrl: String(data?.checkoutUrl || "").trim() || null,
      active: Boolean(data?.active),
    }
    await onSubmit?.(item, {
      isEditMode,
      id: originalIdRef.current,
      originalCode: originalCodeRef.current || null,
    })
    setOpen(false)
  }

  const dlg = (
    <StyledProductGateDialog open={open} onClose={handleClose}>
      <form onSubmit={handleSubmit(handleAction)}>
        <DialogTitle>
          <div className="dialog-title-group">
            <h2 className="dialog-title">
              {isEditMode ? "Edit Product Gate" : "Add Product Gate"}
            </h2>
            <p className="dialog-subtitle">
              Set product identifiers used for content access and checkout
              routing.
            </p>
          </div>
        </DialogTitle>
        <DialogContent>
          {/* Keep ID for edit operations, but don't show it in the UI */}
          <input type="hidden" {...register("id")} />

          <FormControl>
            <TextField
              autoFocus
              autoComplete="off"
              margin="dense"
              label="Product Name"
              fullWidth
              variant="outlined"
              size="small"
              {...register("name", { required: true })}
              error={!!errors?.name}
              helperText={!!errors?.name ? "* Name is required" : " "}
            />
          </FormControl>

          <FormControl>
            <TextField
              autoComplete="off"
              margin="dense"
              label="Product Shortcode (e.g., WTGB)"
              fullWidth
              variant="outlined"
              size="small"
              {...register("code", { required: true })}
              error={!!errors?.code}
              helperText={!!errors?.code ? "* Shortcode is required" : " "}
            />
          </FormControl>

          <FormControl>
            <TextField
              autoComplete="off"
              margin="dense"
              label="HubSpot Content Access ID (optional)"
              fullWidth
              variant="outlined"
              size="small"
              {...register("hubspotContentAccessId", {
                validate: (v) => {
                  if (v === null || v === undefined || String(v).trim() === "") return true
                  const n = Number(v)
                  return Number.isFinite(n) && n > 0
                },
              })}
              error={!!errors?.hubspotContentAccessId}
              helperText={
                !!errors?.hubspotContentAccessId
                  ? "* Must be a positive number"
                  : " "
              }
            />
          </FormControl>

          <FormControl>
            <TextField
              autoComplete="off"
              margin="dense"
              label="Checkout Page URL (optional but recommended)"
              fullWidth
              variant="outlined"
              size="small"
              {...register("checkoutUrl")}
            />
          </FormControl>

          <FormControlLabel
            control={<Switch checked={Boolean(watch("active"))} onChange={(e) => setValue("active", e.target.checked)} />}
            label="Active"
          />

          <input type="hidden" {...register("active")} />
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-cancel-btn"
            variant="outlined"
            size="medium"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="dialog-submit-btn"
            type="submit"
            variant="contained"
            size="medium"
          >
            {isEditMode ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </form>
    </StyledProductGateDialog>
  )

  return [openDlg, dlg]
}

export default ProductGateDlg


